var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import PaymentService from '../../api/PaymentService';
var CollectionDetail = (function (_super) {
    __extends(CollectionDetail, _super);
    function CollectionDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.total = 0;
        _this.listData = [];
        _this.clientId = null;
        _this.businessId = null;
        _this.version = 0;
        return _this;
    }
    CollectionDetail.prototype.created = function () {
        this.service = PaymentService.getInstance();
        if (this.from_system === 4 || this.from_system === 5) {
            this.listData = [this.client];
            this.total = 1;
        }
        else {
            this.getCollectionList();
        }
    };
    CollectionDetail.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 180;
        }, 300);
    };
    CollectionDetail.prototype.getCollectionList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            business_id: this.businessId,
            supplier_to_business_id: this.clientId,
        };
        this.service.getCollectionDetail(Object.assign(params, pager)).then(function (res) {
            if (res.data.success) {
                _this.listData = res.data.data;
                _this.total = res.data.total;
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
            _this.version = res.data.business_config_res && res.data.business_config_res.business_version;
            loadingInstance.close();
        }, function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    CollectionDetail.prototype.pageChange = function (pager) {
        this.getCollectionList(pager);
    };
    CollectionDetail = __decorate([
        Component({
            computed: {
                isShowPrePayment: function () {
                    return this.version >= 3230501;
                },
            }
        })
    ], CollectionDetail);
    return CollectionDetail;
}(Vue));
export default CollectionDetail;
